import { Box, BoxProps } from '@chakra-ui/react/box';

export type DotProps = Omit<BoxProps, 'boxSize'> & {
  size: BoxProps['boxSize'];
};

const Dot = ({ size, ...rest }: DotProps) => <Box aria-hidden borderRadius="full" boxSize={size} {...rest} />;

export default Dot;
